import {
	CalloutCompat as Callout,
	FontWeights,
	mergeStyleSets,
	TextCompat as Text,
	StackCompat as Stack,
	PersonaCompat as Persona,
} from 'components/FluentUICompat';
import * as React from 'react';
import {logout} from 'authentication';
import {useTranslation} from 'react-i18next';
import {useBoolean, useId} from '@fluentui/react-hooks';
import {useMsal} from '@azure/msal-react';
import {useUserContext} from 'authentication/UserContext';
import {ROLE_NAMES} from 'constants/roles';

export const UserSettings: React.FC<any> = () => {
	const {t} = useTranslation('components/usersettings', {
		keyPrefix: 'UserSettings',
	});
	const msal = useMsal();
	const buttonId = useId('callout-button');

	const userName = React.useMemo(
		() => msal.instance.getActiveAccount()?.name,
		[],
	);
	const [isCalloutVisible, {toggle: toggleIsCalloutVisible}] =
		useBoolean(false);

	const {
		isVex,
		isVexSupport,
		isAdmin,
		isServiceProvider,
		isVko,
		isVkoExternal,
		isApprover,
		isReader,
		isBedarfskoordinator,
		isRegulationReader,
		isAvk,
		isBav,
	} = useUserContext();

	const role = React.useMemo(() => {
		const roles = [];
		if (isAdmin) roles.push(ROLE_NAMES.SYSTEM_ADMINISTRATOR);

		if (isVex) roles.push(ROLE_NAMES.VEX);

		if (isVexSupport) roles.push(ROLE_NAMES.VEX_SUPPORT);

		if (isServiceProvider) roles.push(ROLE_NAMES.SERVICE_PROVIDER);

		if (isVko) roles.push(ROLE_NAMES.VKO);

		if (isVkoExternal) roles.push(ROLE_NAMES.VKO_EXTERNAL);

		if (isApprover) roles.push(ROLE_NAMES.APPROVER);

		if (isReader) roles.push(ROLE_NAMES.READER);

		if (isBedarfskoordinator) roles.push(ROLE_NAMES.BEDARFSKOORDINATOR);

		if (isRegulationReader) roles.push(ROLE_NAMES.REGULATION_READER);

		if (isAvk) roles.push(ROLE_NAMES.AVK);

		if (isBav) roles.push(ROLE_NAMES.BAV);

		return roles.join(', ');
	}, [
		isVex,
		isAdmin,
		isServiceProvider,
		isVko,
		isVkoExternal,
		isApprover,
		isReader,
		isBedarfskoordinator,
		isRegulationReader,
		isAvk,
		isVexSupport,
		isBav,
	]);

	return (
		<>
			<Persona
				aria-label='persona'
				id={buttonId}
				text={userName}
				onClick={toggleIsCalloutVisible}
				hidePersonaDetails={true}
				className={styles.userpersonaAppBar}
			/>
			{isCalloutVisible ? (
				<Callout
					ariaLabel='callout'
					className={styles.callout}
					isBeakVisible={false}
					role='dialog'
					target={`#${buttonId}`}
					onDismiss={toggleIsCalloutVisible}
				>
					<Stack horizontal horizontalAlign='space-between'>
						<Stack.Item>
							<Text block variant='xSmall' className={styles.title}>
								Porsche
							</Text>
						</Stack.Item>
						<Stack.Item>
							<Text
								block
								variant='xSmall'
								className={styles.logout}
								onClick={() => logout(msal.instance)}
							>
								{t('SignOut')}
							</Text>
						</Stack.Item>
					</Stack>
					<Stack horizontalAlign='start'>
						<Stack.Item>
							<Persona
								className={styles.userpersonasettings}
								text={userName}
								secondaryText={role}
							/>
						</Stack.Item>
					</Stack>
				</Callout>
			) : null}
		</>
	);
};

const styles = mergeStyleSets({
	button: {
		width: 130,
	},
	callout: {
		paddingTop: '12px',
		width: 320,
		maxWidth: '90%',
		height: '130px',
	},
	title: {
		padding: '10px',
		marginBottom: 12,
		fontWeight: FontWeights.semilight,
	},
	logout: {
		padding: '10px',
		marginBottom: 12,
		fontWeight: FontWeights.semilight,
		cursor: 'pointer',
	},
	userpersonasettings: {
		paddingLeft: '10px',
	},
	userpersonaAppBar: {
		cursor: 'pointer',
	},
});
